import { AnalyticsEvent, AnalyticsManager } from '@oy/analytics';
import { Colors } from '@oy/uicore';
import { Dropdown, Text } from '@oy/uidesktop';
import { SystemIcon } from '@oy/uiicon';
import { useDispatch } from 'react-redux';
import { useTranslate } from 'src/hooks';
import styles from './SelectLang.module.css';

const SelectLang = () => {
  const dispatch = useDispatch();
  const { isLangId } = useTranslate();

  const changeLang = (lang: string) => {
    dispatch({
      type: 'SET_LANG',
      payload: lang,
    });

    AnalyticsManager.instance().track(AnalyticsEvent.click_change_language, {
      language: lang,
      current_url: window.location.pathname,
    });
  };

  return (
    <Dropdown>
      <Dropdown.Button
        id="lang"
        Component="button"
        className={styles.container}
      >
        <SystemIcon name="global" color={Colors.BLACK100} size={16} />
        <Text textStyle={Text.Style.BodyMdRegular} color={Colors.BLACK100}>
          {isLangId ? 'Indonesia' : 'English'}
        </Text>
        <SystemIcon
          name="arrow-down"
          color={Colors.BLACK100}
          className={styles.chevron}
          size={10}
        />
      </Dropdown.Button>
      <Dropdown.Menu
        style={{
          width: '140px',
          boxShadow: '0px 2px 6px rgba(30, 43, 55, 0.2)',
        }}
      >
        <Dropdown.MenuItem onClick={() => changeLang('id')}>
          <Text
            id="lstLangId"
            textStyle={Text.Style.BodyMdRegular}
            color={Colors.BLACK100}
          >
            Indonesia
          </Text>
        </Dropdown.MenuItem>
        <Dropdown.MenuItem onClick={() => changeLang('en')}>
          <Text
            id="lstLangEn"
            textStyle={Text.Style.BodyMdRegular}
            color={Colors.BLACK100}
          >
            English
          </Text>
        </Dropdown.MenuItem>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SelectLang;
